import { useEffect } from 'react'
import { useEsri } from '../hooks'

const esriReqs = ['esri/widgets/BasemapToggle']

const Toggle = ({ map, view, position, next }) => {
  const [ready, { BasemapToggle }] = useEsri(esriReqs)

  useEffect(() => {
    if (ready && map && view) {
      const basemapToggle = new BasemapToggle({
        view,
        nextBasemap: next || 'satellite'
      })
      view.ui.add(basemapToggle, position || 'top-right')
    }
  }, [ready, BasemapToggle, map, view, position, next])

  return null
}

export default Toggle
